<template>
  <v-bottom-sheet v-model="consultaCupomModel" scrollable inset retain-focus>
    <v-card min-height="400">
      <v-toolbar color="#0c0a43" dark max-height="64">
        <v-toolbar-title class="">Consultar Cupons</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text @click="setConsultarCupom(false)"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar-items>
      </v-toolbar>

      <v-card-subtitle class="pt-5" :style="{ 'box-shadow': '1px' }">
        <v-row>
          <v-col>
            <v-text-field
              label="CPF/CNPJ"
              placeholder="Informe seu CPF/CNPJ"
              persistent-placeholder
              class="title"
              v-mask="'##############'"
              v-model="pesquisaModel"
              autofocus
            ></v-text-field>
            <v-btn
              block
              rounded
              outlined
              color="primary"
              class="font-weight-bold"
              @click="carregarCupons()"
              :loading="carregandoCupons"
            >
              <v-icon left>mdi-magnify</v-icon> Buscar cupons</v-btn
            >
          </v-col>
          <v-col cols="12" v-if="buscou_cupom && !carregandoCupons">
            <v-chip
              ><span
                >Você possui
                <span class="title font-weight-bold">{{
                  sorteio.cupons_validos
                }}</span>
                cupons válidos</span
              ></v-chip
            >
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text class="pt-3">
        <template v-if="buscou_cupom">
          <v-progress-linear
            indeterminate
            v-if="carregandoCupons"
            class="mt-2"
          ></v-progress-linear>
          <v-alert
            type="info"
            text
            class="mt-3"
            v-else-if="sorteio.cupons.length == 0"
          >
            <span class="body-1">Nenhum cupom encontrado</span>
          </v-alert>
          <v-row v-else class="justify-center">
            <v-col
              xl="auto"
              lg="auto"
              md="auto"
              cols="6"
              v-for="(cupom, i) in getCuponsPagina()"
              :key="i"
              
            >
              <v-img src="../assets/ticket.png">
                <template v-if="isMobile()">
                  <span class="cupom-cancelado-mobile" v-if="cupom.cancelado">
                    CANCELADO</span
                  >
                  <p class="pa-0 ml-8 mb-0 mt-3">Cupom</p>
                  <p class="pa-0 ml-8 mt-0 mb-3 numero-cupom-mobile">
                    {{ cupom.cupom }}
                  </p>
                </template>
                <template v-else>
                  <span class="cupom-cancelado" v-if="cupom.cancelado">
                    CANCELADO</span
                  >
                  <p class="pa-0 ml-10 mb-0 mt-4">Cupom</p>
                  <p class="pa-0 ml-10 mt-0 mb-3 numero-cupom">
                    {{ cupom.cupom }}
                  </p>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions class="grey lighten-2 justify-center">
        <v-pagination
          v-if="sorteio.paginas > 0 && buscou_cupom"
          v-model="page"
          :length="sorteio.paginas"
          circle
          total-visible="10"
        ></v-pagination>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  watch: {
    consultar_cupom: function (open) {
      if (open) {
        this.setBuscouCupom(false);
      }
    },
  },
  computed: {
    ...mapState([
      "pesquisa",
      "carregandoCupons",
      "sorteio",
      "buscou_cupom",
      "consultar_cupom",
    ]),
    consultaCupomModel: {
      get: function () {
        return this.consultar_cupom;
      },
      set: function (value) {
        this.setConsultarCupom(value);
      },
    },
    pesquisaModel: {
      get: function () {
        return this.pesquisa;
      },
      set: function (value) {
        this.setPesquisa(value);
      },
    },
  },
  data: () => ({
    dialog: false,
    page: 1,
  }),
  methods: {
    ...mapMutations([
      "setPesquisa",
      "resetSorteio",
      "setBuscouCupom",
      "setConsultarCupom",
    ]),
    ...mapActions(["getCupons"]),
    isMobile() {
      return this.$mq == "sm";
    },
    getCuponsPagina() {
      return this.sorteio.cupons.filter((s) => s.pagina == this.page);
    },
    getImg(cupom) {
      return cupom.cancelado
        ? require("../assets/ticket-cancelado.png")
        : require("../assets/ticket.png");
    },
    async carregarCupons() {
      this.page = 1;
      await this.getCupons();
    },
  },
};
</script>

<style>
.cupom-cancelado {
  position: absolute;
  color: rgba(255, 0, 0, 0.63);
  font-size: 1.2rem;
  rotate: 343deg;
  margin-top: 28px;
  margin-left: 22px;
  letter-spacing: 1.8px;
  font-family: "Archivo Black";
  z-index: -1;
}

.cupom-cancelado-mobile {  
  width: 200px;
  height: 100px;
  position: absolute;
  color: rgba(255, 0, 0, 0.6);
  font-size: 4.5vw;
  transform: rotate(343deg);
  margin-top: 2vw;
  margin-left: 7vw;
  font-family: "Archivo Black";
  z-index: -1;
}

.numero-cupom {
  font-family: "Archivo Black";
  font-size: 1.25em;
}

.numero-cupom-mobile {
  font-family: "Archivo Black";
  font-size: 1em;
}
</style>